import { StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';

import { RIBBON_CONTAINER_PADDING } from 'components/Ribbon/styles';

const styles = StyleSheet.create({
    root: {
        backgroundColor: COLOR.BLACK,
        paddingHorizontal: RIBBON_CONTAINER_PADDING,
    },
    keyboardAvoiding: {
        flex: 1,
        backgroundColor: COLOR.BLACK,
    },
    loadingContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    noResultsContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        marginHorizontal: 32,
    },
    bottomIndent: { paddingBottom: 50 },
});

export default styles;
